<template>
	<div class="wechat">
		<div class="fixation">
			<div class="hint">
				<div class="left">
					订单已经提交，请尽快支付！
					<span>订单号：{{series}}</span>
				</div>
				<div class="right">
					应付金额：{{money}}元
				</div>
			</div>
			<div class="payarea">
				<div class="title">
					微信支付
					<div class="timer">
						距离二维码过期还有<span>{{timer}}</span>秒，过期后请刷新页面重新获取二维码。
					</div>
				</div>
				<div class="qrcode">
					<div class="left">
						<div class="image">
							<qriously v-if="qrcode!=''" :value="qrcode" :size="260"></qriously>
							<el-empty v-else description="请稍候"></el-empty>
							<!-- <img :src="qrcode" alt=""> -->
						</div>
						<div class="explain">
							<img src="../../../assets/scanner.png" alt="">
							请使用微信扫一扫扫描二维码支付
						</div>
					</div>
					<div class="right">
						<img src="../../../assets/wechat-hint.png" alt="">
					</div>
				</div>
				<div class="back" @click="goBack">
					<i class="el-icon-arrow-left"></i>
					选择其它支付方式
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'wechat',
		data() {
			return {
				series: '',
				money: '',
				timer: 600,
				qrcode: '',
				lotId: ''
			};
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			fetchData() {
				this.$api.frontWxPay({
					orderNo: this.series,
					payType: this.type,
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.qrcode = res.data
						this.timeMachine()
					}
				})
			},
			timeMachine() {
				let interVal = setInterval(() => {
					if (this.timer > 0) {
						if (this.timer % 10 == 0 && this.timer < 600) {
							this.$api.frontOrderStatus({
								orderNo: this.series,
								userId: this.$store.state.userinfo.userId
							}, res => {
								if (res.code == 200) {
									if (res.data == 1) {
										clearInterval(interVal)
										this.$router.push({
											path: '/success',
											query: {
												id: this.lotId
											}
										})
									}
								}
							})
						}
						this.timer--
					} else {
						clearInterval(interVal)
						this.$alert('请关闭页面', '支付失败', {
							confirmButtonText: '确定',
							callback: () => {
								this.$router.push({
									path: '/auction',
									query: {
										id: this.lotId
									}
								})
							}
						})
					}
				}, 1000)
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.series = this.$route.query.order
			this.type = this.$route.query.type
			this.lotId = this.$route.query.lotId
			this.money = this.$route.query.money
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		margin-top: @vue-spacing-col-lg*2;

		.hint {
			width: 100%;
			height: 50px;
			display: flex;
			justify-content: space-between;
			font-size: @vue-font-size-base - 4;
			margin-bottom: @vue-spacing-col-base;

			.right {
				color: @vue-text-color-red;
			}
		}

		.payarea {
			width: 100%;
			margin: @vue-spacing-col-lg 0px;
			box-shadow: 0px 0px 10px @vue-border-color;

			.title {
				width: 100%;
				height: 50px;
				border-bottom: 1px solid @vue-border-color;
				padding: 0px @vue-spacing-row-lg;
				box-sizing: border-box;
				display: flex;
				align-items: center;

				.timer {
					margin-left: @vue-spacing-row-lg * 2;

					span {
						color: @vue-text-color-red;
					}
				}
			}

			.qrcode {
				padding: 0px @vue-spacing-row-lg;
				box-sizing: border-box;
				width: 100%;
				height: 540px;
				display: flex;
				justify-content: space-between;

				.left {
					width: 50%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					align-content: center;
					flex-wrap: wrap;

					.image {
						width: 300px;
						height: 300px;
						border: 1px solid @vue-border-color;
						box-sizing: border-box;
						padding: 18px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.explain {
						width: 300px;
						height: 60px;
						background: @vue-bg-color-red;
						color: @vue-text-color-inverse;
						margin-top: @vue-spacing-col-base;
						padding: 0px @vue-spacing-row-lg*2;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						img {
							width: 30px;
							height: 30px;
							margin-right: @vue-spacing-row-base;
						}
					}
				}

				.right {
					width: 50%;
					height: 100%;
					display: flex;
					align-items: center;
				}
			}

			.back {
				width: 100%;
				height: 70px;
				border-top: 1px solid @vue-border-color;
				padding: 0px @vue-spacing-row-lg;
				box-sizing: border-box;
				line-height: 70px;
				color: @vue-text-color-active;
				font-size: @vue-font-size-base - 4;
			}
		}
	}
</style>
